import React, { Component } from 'react';

import { Dropdown, DropdownItem } from 'components/dropdown';
import { I18n } from 'components/translate';
import Settings from 'configs/Settings';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { AuthService } from 'modules/auth';
import { UserPhotoLogged } from 'modules/user';
import PropTypes from 'prop-types';

import HeaderEvents from './events';
import HeaderUserBoxProfile from './HeaderUserBoxProfile';

import './HeaderUser.scss';

const EVENT_WHERE = 'Account';

class HeaderUser extends Component {
  static propTypes = {
    onClick: PropTypes.func
  };

  state = {
    profileImage: {
      avatar: '',
      avatarResize: ''
    }
  };

  logoutClickHandler(e) {
    e.preventDefault();
    e.stopPropagation();

    HeaderEvents.sendClick({ where: EVENT_WHERE, label: 'Exit' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        action: EVENTS_INTERACTIONS.CLICK,
        category: EVENTS_CATEGORY.HORIZONTAL_MENU.HORIZONTAL_MENU_ACCOUNT,
        label: EVENTS_LABELS.EXIT
      })
    });

    AuthService.logoutUser();
  }

  async onMyAccountClick() {
    HeaderEvents.sendClick({ where: EVENT_WHERE, label: 'MyAccount' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        action: EVENTS_INTERACTIONS.CLICK,
        category: EVENTS_CATEGORY.HORIZONTAL_MENU.HORIZONTAL_MENU_ACCOUNT,
        label: EVENTS_LABELS.MY_ACCOUNT
      })
    });
  }

  handleOpenDropdown = () => {
    this.props.onClick?.();
  };

  render() {
    return (
      <Dropdown
        onClick={this.handleOpenDropdown}
        className="header__user"
        dropdownToggle={<UserPhotoLogged />}
      >
        <HeaderUserBoxProfile />

        <ul className="nav__dropdown">
          <a
            className="dropdown__menu__item"
            target="_blank"
            rel="noreferrer noopener"
            href={`${Settings.app.account}?systemOrigin=club-admin`}
          >
            <I18n label="general.my_account" />
          </a>
          <DropdownItem
            text="general.logout"
            onClick={this.logoutClickHandler}
          />
        </ul>
      </Dropdown>
    );
  }
}

export default HeaderUser;
